import { FederatedMFE } from '@pwc/pwc-deals-ui';
import featureFlags from 'common/helpers/featureFlags';
import { LiveReportPreviewMFEProps } from '../types';
import styles from '../index.module.scss';

const LiveReportPreviewMFE: React.FC<LiveReportPreviewMFEProps> = (
  props: LiveReportPreviewMFEProps
) => {
  const { entityType } = props;

  return (
    <div className={styles['live-report-preview--wrapper']}>
      <FederatedMFE
        url={String(process.env.REACT_APP_LIVE_REPORT_PREVIEW_MFE_URL)}
        scope="remoteapp"
        componentModule="./LiveReportPreview"
        suspenseFallbackStyle={styles['live-report-preview-loader-wrapper']}
        props={{
          ...props,
          entityType,
          featureFlags: {
            isLRPLoaderFlagEnabled: featureFlags?.isLRPLoaderFlagEnabled,
          },
        }}
      />
    </div>
  );
};

export default LiveReportPreviewMFE;
